<div
	mat-dialog-title
	[align]="'end'">
	<mat-icon
		class="cursor-pointer"
		mat-dialog-close>
		close
	</mat-icon>
</div>
<div mat-dialog-content>
	@if (isProcessing) {
		<div class="flex flex-col items-center justify-center gap-3 py-12 text-gray-500">
			<mat-spinner
				color="primary"
				diameter="48" />
			<p>{{ "videos.video.processing" | translate }}</p>
		</div>
	} @else if (!playbackUrl) {
		<div class="flex justify-center py-8">
			<mat-spinner
				color="primary"
				diameter="40" />
		</div>
	} @else {
		<mux-player
			[attr.src]="playbackUrl"
			[attr.poster]="thumbnailUrl"
			[attr.env-key]="muxEnvKey"
			[attr.metadata-video-id]="data.id"
			[attr.metadata-video-title]="data.label"
			[attr.metadata-viewer-user-id]="viewerUserId"
			[attr.metadata-video-stream-type]="'on-demand'"
			[attr.player-init-time]="playerInitTime"
			controls></mux-player>
	}
	@if (data.chapters.length > 0) {
		<div class="text-2xl font-bold text-blue-400 mt-3 mb-2">
			{{ "videos.video.chapters.label" | translate }}
		</div>
		<div class="grid grid-cols-4 gap-3">
			@for (chapter of data.chapters; track chapter.id) {
				<div class="flex flex-row w-full gap-x-2">
					<mat-icon
						class="cursor-pointer"
						(click)="goTo(chapter)">
						control_camera
					</mat-icon>
					<div
						(click)="goTo(chapter)"
						class="cursor-pointer">
						{{ chapter.label }}
					</div>
				</div>
			}
		</div>
	}
</div>
